import React, { useState } from "react";
import moment from "moment";
import { useNavigate } from 'react-router-dom';
import { useData } from "../../../context/DataContext";
import { createTrainingPlan } from '../../../context/createAPI';
import { Box, Card, CardActions, CardContent, Divider, Grid, TextField } from "@mui/material";
import SingleSelect from "../../../components/Selections/singleSelect";
import CustomButton from "../../../components/buttons/customButton";
import SnackbarMessage from "../../../components/snackBar/snackBar";

const initialState = {
    trainingName: "",
    trainingDate: moment().format("YYYY-MM"),
    year: "",
    levelId: "",
    trainingTopic: "",
    targetGroup: "",
    resourcePerson: "",
    trainingMethodology: "",
    comments: "",
    loading: false,
    submitMssg: "",
    trainingTypeId: "",
}


function TrainingCreation() {
    const currentYear = new Date().getFullYear();
    const currentMonth = String(new Date().getMonth() + 1).padStart(2, '0');
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

    const navigate = useNavigate();
    const { user = {}, years = [], levels = [], handleTrainingPlans, trainingTypes = [] } = useData();


    const [state, setState] = useState(initialState);
    const [errors, setErrors] = useState({});

    const handleInputChange = (name, value) => {      
        setState((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors({});
    };


    const handleTrainingCreationSubmit = async (e) => {
        e.preventDefault();
        const formErrors = {};
        if (!state.trainingName) formErrors.trainingName = "Enter Training Name";
        if (!state.levelId) formErrors.levelId = "Select Level";
        if (!state.trainingTopic) formErrors.trainingTopic = "Enter Topic";
        if (!state.targetGroup) formErrors.targetGroup = "Enter Target Group";
        if (!state.trainingDate) formErrors.trainingDate = "Select Date";
        if (!state.resourcePerson) formErrors.resourcePerson = "Enter Resource Person";
        if (!state.trainingMethodology) formErrors.trainingMethodology = "Enter Methodology";
        if (!state.trainingTypeId) formErrors.trainingTypeId = "Select Training Type";

        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setState((prevState) => ({
                ...prevState,
                loading: true
            }));
            try {
                const createApi = await createTrainingPlan({
                    level_id: state.levelId,
                    training_content: state.trainingName.replace(/\n/g, " "),
                    training_type_id: state.trainingTypeId,
                    year: years[0]?.value,
                    month_of_training: state.trainingDate,
                    training_topics: state.trainingTopic.replace(/\n/g, " "),
                    target_group: state.targetGroup.replace(/\n/g, " "),
                    resource_person: state.resourcePerson.replace(/\n/g, " "),
                    training_methodology: state.trainingMethodology.replace(/\n/g, " "),
                    comments: state.comments.replace(/\n/g, " "),
                    client_id: parseInt(localStorage.getItem("user_client_id")),
                    inserted_by: user.user_id
                });
                if (createApi.statusCode === 200) {
                    setState((prevState) => ({
                        ...prevState,
                        loading: false,
                        submitMssg: createApi.data
                    }));

                    setSnackbar({
                        open: true,
                        message: createApi.data,
                        severity: "success",
                    });

                    handleTrainingPlans();
                    setTimeout(() => {
                        navigate(-1);
                    }, 2000);
                }

            } catch (error) {
                console.error(error);
                setSnackbar({
                    open: true,
                    message: error,
                    severity: "error",
                });
            }
        }

    }

    const { trainingTypeId, year, levelId, trainingName, trainingDate, trainingTopic, targetGroup, resourcePerson, trainingMethodology, comments, loading } = state;

    return (
        <Box>
            <Card elevation={6}>
                <CardContent>
                    <Grid container spacing={2}>
                        {[
                            { id: 1, name: "trainingTypeId", value: trainingTypeId, label: "Training Type", type: "select", options: trainingTypes, error: errors.trainingTypeId },
                            { id: 2, name: "trainingName", value: trainingName, label: "Training Name", type: "textarea", limit: 150, error: errors.trainingName, rows: 3 },
                            { id: 3, name: "trainingDate", value: trainingDate, label: "Training Month", type: "month", error: errors.trainingDate },

                            { id: 4, name: "year", label: "Training Year", type: "select", value: years[0]?.value ?? year, options: years[0] ? [years[0]] : [], disabled: true, error: errors.year },
                            { id: 5, name: "levelId", label: "Levels", value: levelId, type: "select", options: levels, error: errors.levelId },
                            { id: 6, name: "trainingTopic", value: trainingTopic, label: "Training Topic", type: "textarea", limit: 300, error: errors.trainingTopic, rows: 3 },

                            { id: 7, name: "targetGroup", value: targetGroup, label: "Target Audience", type: "textarea", limit: 300, error: errors.targetGroup, rows: 3 },
                            { id: 8, name: "resourcePerson", value: resourcePerson, label: "Resource Person", type: "textarea", limit: 300, error: errors.resourcePerson, rows: 3 },
                            { id: 9, name: "trainingMethodology", value: trainingMethodology, label: "Training Methodology", type: "textarea", limit: 300, error: errors.trainingMethodology, rows: 3 },

                            { id: 10, name: "comments", value: comments, label: "Comments", type: "textarea", limit: 500, rows: 3 },
                        ].map((field) => (
                            <Grid item size={{ xs: 12, md: 4 }} key={field.id}>
                                {/* SELECT */}
                                {field.type === "select" && (
                                    <SingleSelect
                                        name={field.name}
                                        label={field.label}
                                        options={field.options}
                                        value={field.value}
                                        disabled={field.disabled}
                                        onChange={handleInputChange}
                                        error={field.error}
                                        formHelperText={true}
                                    />
                                )}

                                {/* TEXTAREA */}
                                {field.type === "textarea" && (
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={field.rows}
                                        name={field.name}
                                        label={field.label}
                                        value={field.value}
                                        onChange={(e) => handleInputChange(field.name, e.target.value)}
                                        inputProps={{ maxLength: field.limit }}
                                        error={!!field.error}
                                        helperText={
                                            field.error ||
                                            (field.limit
                                                ? `${(state[field.name] || "").length}/${field.limit}`
                                                : "")
                                        }
                                    />
                                )}

                                {/* MONTH */}
                                {field.type === "month" && (
                                    <TextField
                                        fullWidth
                                        type="month"
                                        size="small"
                                        name={field.name}
                                        label={field.label}
                                        value={field.value}
                                        onChange={(e) => handleInputChange(field.name, e.target.value)}
                                        error={!!field.error}
                                        helperText={field.error}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>

                <Divider sx={{ bgcolor: '#f5f1f1ff' }} />

                <CardActions sx={{ justifyContent: "center", mb: 1, mt: 1 }}>
                    <CustomButton
                        status={state.loading === true ? "loading" : "idle"}
                        onClick={handleTrainingCreationSubmit}
                        label=" Create Plan"
                        loadingLabel="Submitting.."
                    />
                </CardActions>
            </Card>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </Box>
    );
}
export default TrainingCreation;